import { EmpresaTreeViewService } from './../../../../employee/services/empresa-treeView.service';
import { AtributosService } from './../../../../company-view/services/atributos.service';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import * as moment from 'moment';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';
import { LeaveService } from 'app/modules/leave/services/leave.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { ActuationService } from 'app/modules/employee-view/services/actuation.service';
import { ComentariopopupComponent } from '../../popups/comentariopopup/comentariopopup.component';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { RecordingsService } from 'app/modules/selection-generic/services/recordings.service';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';

@Component({
    selector: 'app-actuation-list',
    templateUrl: './actuation-list.component.html',
    styleUrls: ['./actuation-list.component.scss'],
    standalone: false
})
export class ActuationListComponent implements OnInit {
    displayedColumns: any[];
    marcaOptionList: any[];
    RevisionOptionList: any[];
    OrdenFormGroup: UntypedFormGroup;
    public selectedRowIndex = 0;
    attributeList=[];
    public isFirstTime:boolean=true;

    constructor(
        public selectionService: SelectionGenericService,
        public filterService: FilterService,
        private leaveService: LeaveService,
        private changeDetectorRefs: ChangeDetectorRef,
        private sharedService: SharedService,
        private actuationService: ActuationService,
        public dialog: MatDialog,
        private fb: UntypedFormBuilder,
        public recordingService: RecordingsService,
        private pageLoaderService: PageLoaderService,
        private _atributosService: AtributosService,
        public empresaTreeViewService: EmpresaTreeViewService,
        private changeDetect: ChangeDetectorRef
    ) {
        this.empresaTreeViewService.EmpId.subscribe((_res: any) => {
            if (_res > 0) {
             
                this.isFirstTime=true;
                this.loadAttributes(_res)
            }
        }); 
    }

    ngOnInit(): void {
        this.loadAttributes(parseInt(localStorage.getItem('Empresa')))
        this.selectionService.setPermissionForContextMenu();
        this.marcaOptionList = [
            {
                text: 'Marca de empresa',
                className: 'lbl3',
                label: 'E',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'Marca de médico',
                className: 'lbl4',
                label: 'M',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'Marca de coordinador',
                className: 'lbl2',
                label: 'C',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'Marca de mutua',
                className: 'lbl8',
                label: 'U',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'Marca externa',
                className: 'lbl7',
                label: 'X',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'No citado por diagnóstico',
                className: 'lbl7',
                label: 'D',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'No citado por zona',
                className: 'lbl7',
                label: 'Z',
                isPermit:
                    this.selectionService.selectionPermissions
                        .HasMarcaExternalView,
            },
            {
                text: 'Marca de simulación',
                className: 'lbl7',
                label: 'S',
                isPermit: this.selectionService.selectionPermissions.HasMarcaView,
            },
            {
                text: 'Marca de salud mental',
                className: 'lbl7',
                label: 'L',
                isPermit:
                    this.selectionService.selectionPermissions.HasMarcaView,
            },
        ];

        this.RevisionOptionList = [
            { text: 'Orden Visitar', value: 20101 },
            { text: 'Orden No Visitar', value: 29001 },
            { text: 'Orden Contactar', value: 21101 },
            { text: 'Orden FPA', value: 25102 },
            { text: 'Comentario', value: 0 },
        ];

        this.InitForm();
    }

    refreshDisplayColumns()
    {
        this.displayedColumns = [
            {
                name: 'Actions',
                column: 'action',
                show: true,
                isPermit: true,
                disabled: true,
            },
            {
                name: 'Revisión',
                column: 'revision',
                show: true,
                isPermit: true,
                disabled: false,
            },

            {
                name: 'Revisada',
                column: 'revisada',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasFechaRevision,
                disabled: true,
            },
            {
                name: 'Marcas',
                column: 'marcas',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Grabacion',
                column: 'grabacion',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasGrabacion,
                disabled: false,
            },
            {
                name: 'Documento',
                column: 'documento',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasDocumento,
                disabled: false,
            },
            {
                name: 'Empresa',
                column: 'empresa',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Proyecto',
                column: 'proyecto',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 1',
                column: 'nivel1',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 2',
                column: 'nivel2',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 3',
                column: 'nivel3',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 4',
                column: 'nivel4',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Nivel 5',
                column: 'nivel5',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Referencia',
                column: 'referencia',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Referencia de Baja',
                column: 'leaveRef',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'NIF',
                column: 'nif',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Trabajador',
                column: 'trabajador',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Provincia',
                column: 'provincia',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Poblacion',
                column: 'poblacion',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'CP',
                column: 'cp',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Prioritaria',
                column: 'prioritaria',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Tipo',
                column: 'tipo',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Baja',
                column: 'fBaja',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Alta',
                column: 'fAlta',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Médico',
                column: 'medico',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'NJ',
                column: 'nj',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Fecha NJ',
                column: 'fechaNJ',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Dias NJ',
                column: 'diasNJ',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'FPA',
                column: 'fpa',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Diagnóstico',
                column: 'diagnostico',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos505,
                disabled: false,
            },
            {
                name: 'Grupo D.',
                column: 'grupoD',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos505,
                disabled: false,
            },
            {
                name: 'Atributos',
                column: 'atributos',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[0].attributoName,
                column: 'tAttr1',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[1].attributoName,
                column: 'tAttr2',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[2].attributoName,
                column: 'tAttr3',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[3].attributoName,
                column: 'tAttr4',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[4].attributoName,
                column: 'tAttr5',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[5].attributoName,
                column: 'tAttr6',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[6].attributoName,
                column: 'tAttr7',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[7].attributoName,
                column: 'tAttr8',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[8].attributoName,
                column: 'tAttr9',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[9].attributoName,
                column: 'tAttr10',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[10].attributoName,
                column: 'tAttr11',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: this.attributeList[11].attributoName,
                column: 'tAttr12',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Fecha',
                column: 'fecha',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Hora',
                column: 'hora',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Actuacion',
                column: 'actuacion',
                show: true,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Pdte. Contestar',
                column: 'PdteContestar',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Aprobada',
                column: 'Aprobada',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Rechazada',
                column: 'Rechazada',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Estado de SMS',
                column: 'smsEstado',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Autor',
                column: 'autor',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos510,
                disabled: false,
            },
            {
                name: 'Importe Médico',
                column: 'importeMedico',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasImporteMedico,
                disabled: false,
            },
            {
                name: 'Texto',
                column: 'texto',
                show: true,
                isPermit: this.selectionService.selectionPermissions.HasTexto,
                disabled: false,
            },
            {
                name: 'F. Revisión',
                column: 'fRevision',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos511,
                disabled: false,
            },
            {
                name: 'Coordinador',
                column: 'coordinador',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos511,
                disabled: false,
            },
            {
                name: 'Com. Rev.',
                column: 'comRev',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos511,
                disabled: false,
            },
            {
                name: 'Orden Rev.',
                column: 'ordenRev',
                show: true,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos511,
                disabled: false,
            },
            {
                name: 'F. Citación',
                column: 'fCitacion',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Doc. Citación',
                column: 'docCitacion',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'Resp. Sol',
                column: 'respSol',
                show: false,
                isPermit: this.selectionService.selectionPermissions.HasRespSol,
                disabled: false,
            },
            {
                name: 'F. Resp. Sol',
                column: 'fRespSol',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Progr. Sol',
                column: 'fProgrSol',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Real. Sol',
                column: 'fRealSol',
                show: false,
                isPermit: true,
                disabled: false,
            },
            {
                name: 'F. Registro',
                column: 'fRegistro',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos510,
                disabled: false,
            },
            {
                name: 'Usuario',
                column: 'usuario',
                show: false,
                isPermit:
                    this.selectionService.selectionPermissions.HasPermisos510,
                disabled: false,
            },
        ];
        this.actuationService.acctuacionColumns=[];
            this.displayedColumns.forEach(element => {
                if(element.show && element.isPermit) {
                    this.actuationService.acctuacionColumns.push(element.name)
                }
            });
    }

    loadAttributes(empresaId)
    {
        this._atributosService.GetAttributoEmpresa(empresaId)
        .subscribe(res => {
        if (res.result) {
            this.attributeList=res.result;
            this.refreshDisplayColumns();
        }
        });
    }

    public getAutorTooltip(actuation: any): string {
        if (!actuation) return '';

        if (!actuation.autor || actuation.autor === '') {
            return 'Sin autor asignado';
        }
        
        const text = String(actuation.autor);
        return text.length > 50 ? text.substring(0, 50) + '...' : text;
    }

    InitForm(): void {
        const today = moment();
        this.OrdenFormGroup = this.fb.group({
            Employee: this.fb.group({
                EmployeeId: ['', Validators.required],
                LeaveId: ['', Validators.required],
            }),
            Gestion: this.fb.group({
                TipoAutor: ['C'],
                Type: [''],
                Date: [today],
                Autor: [this.sharedService.getCurrentUser().coordinador],
            }),
        });
    }

    getDisplayedColumns(): string[] {
        return this.displayedColumns
            .filter((cd) => cd.show && cd.isPermit)
            .map((cd) => cd.column);
    }

    toggleDisplayColumn(columnName, value): any {
        this.displayedColumns.filter((c) => c.column === columnName)[0].show =
            value;

            this.actuationService.acctuacionColumns=[];
            this.displayedColumns.forEach(element => {
                if(element.show) {
                    this.actuationService.acctuacionColumns.push(element.name)
                }
            });
    }

    public getActions(pageEvent: PageEvent): void {
        this.selectionService.GetActuationSelection(
            pageEvent.pageIndex,
            pageEvent.pageSize,
            false
        );
    }

    public getLeaveRecord(row, event): any {
        const isExcept = event.target.classList.contains('except');
        if (!isExcept && this.selectionService.isShowLeavePanel) {
            this.selectedRowIndex = row.actuacionId;
            this.selectionService.getLeaveRecord(row);
        }
    }

    public toggleMarca(leaveRow: any, marca: any, checked: boolean): void {
        let marcaString = '';
        if (leaveRow.marcas !== null) {
            marcaString = String(leaveRow.marcas);
        }
        if (checked) {
            marcaString = marcaString.concat(marca.label);
        } else {
            marcaString = marcaString.replace(marca.label, '');
        }

        this.leaveService
            .UpdateLeaveMarca(leaveRow.bajaId, { marcas: marcaString })
            .subscribe(
                (res) => {
                    if (res.code === 0 && res.result) {
                        const sameLeaveItems =
                            this.selectionService.dataSource.data.filter(
                                (e) => e.bajaId === leaveRow.bajaId
                            );
                        sameLeaveItems.forEach((rowItem) => {
                            const index =
                                this.selectionService.dataSource.data.indexOf(
                                    leaveRow
                                );
                            rowItem.marcas = marcaString;
                            this.selectionService.dataSource.data.splice(
                                index,
                                1,
                                rowItem
                            );
                        });
                        this.changeDetectorRefs.detectChanges();
                    }
                },
                (error) => {
                    this.sharedService.ShowSnackBar(
                        'Actualización de marca fallida'
                    );
                    console.error(error);
                }
            );
    }

    public updateValu(obj): void {
        const Coordinador = this.sharedService.getCurrentUser().coordinador;
        this.actuationService
            .UpdateActuationEstado(obj.actuacionId, Coordinador)
            .subscribe(
                (res) => {
                    if (res.code === 0) {
                        this.sharedService.ShowSnackBar(
                            'Actualizado exitosamente'
                        );
                    } else {
                        this.sharedService.ShowSnackBar('Ocurrió un error');
                    }
                },
                (err) => {
                    console.error(err);
                }
            );
    }

    public onClickRevision(value, obj): void {
        this.OrdenFormGroup.get(['Employee', 'EmployeeId']).setValue(
            obj.trabajadorId
        );
        this.OrdenFormGroup.get(['Employee', 'LeaveId']).setValue(obj.bajaId);

        switch (value) {
            case 0:
                const ref = this.dialog.open(ComentariopopupComponent, {
                    width: '400px',
                });
                ref.componentInstance.actuation = obj;
                break;
            case 20101:
                this.OrdenFormGroup.get(['Gestion', 'Type']).setValue(20101);
                this.submitForm();
                break;
            case 29001:
                this.OrdenFormGroup.get(['Gestion', 'Type']).setValue(29001);
                this.submitForm();
                break;
            case 21101:
                this.OrdenFormGroup.get(['Gestion', 'Type']).setValue(21101);
                this.submitForm();
                break;
            case 25102:
                this.OrdenFormGroup.get(['Gestion', 'Type']).setValue(25102);
                this.submitForm();
                break;
        }
    }

    submitForm(): void {
        this.actuationService
            .createOrden(this.OrdenFormGroup.getRawValue())
            .subscribe(
                (res) => {
                    if (res.code === 0) {
                        this.sharedService.ShowSnackBar(
                            'Actualizado exitosamente'
                        );
                    } else {
                        this.sharedService.ShowSnackBar('Ocurrió un error');
                    }
                },
                (err) => {
                    console.error(err);
                }
            );
    }

    public confirmMatch(action: any): void {
        action.isMatching = true;
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: new ConfirmDialogModel(
                'Confirmar acción',
                '¿Enlazar la grabación?'
            ),
        });
        dialogRef.afterClosed().subscribe((responce) => {
            if (responce) {
                this.acceptMatch(action);
            }
            action.isMatching = false;
        });
    }

    private acceptMatch(action: any): void {
        this.pageLoaderService.ShowPageLoader();
        this.recordingService.acceptMatch(action).subscribe(
            (res) => {
                this.sharedService.ShowSnackBar('Se ha enlazado la grabación');
                this.recordingService.recordMatched.emit(true);
                this.pageLoaderService.HidePageLoader();
            },
            (error) => {
                console.error(error);
                this.sharedService.ShowSnackBar(
                    'Error al enzalar la grabación'
                );
                this.pageLoaderService.HidePageLoader();
            }
        );
    }
}
